module.exports = __webpack_public_path__ + "img/evaluation-2018-award.f53bc0d2.jpg";